import BootstrapTable from "react-bootstrap-table-next";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import "./../main.scss";
import "./table.scss";
import OneInvoiceKn from "./OneInvoiceKn";
import OneInvoiceDvojnoKn from "./OneInvoiceDvojnoKn";
import OneInvoiceDvojnoEur from "./OneInvoiceDvojnoEur";
import OneInvoiceEur from "./OneInvoiceEur";
import Pagination from "react-js-pagination";
//import Axios from 'axios'
import checkJwt from "./../../../Global/jwtChecker";
import logout from "./../../../Global/logout";
import { AiFillEdit } from "react-icons/ai";
import { BsCaretDown, BsCaretUp } from "react-icons/bs";
import Loader from "./../../../Global/loader";
import clientInvoices from "./../../../API/Client/GetInvoices";
import SearchedInvoicesToExcel from "./SearchedInvoicesToExcel";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export class RacuniTable extends React.Component {
    constructor(props) {
        super(props);

        this.toggleInvoiceVisibility = this.toggleInvoiceVisibility.bind(this);

        this.state = {
            loading: true,
            error: false,
            signin: true,
            racunVisible: false,
            oneInvoice: null,
            invoices: null,
            loadingAllToExcel: false,
            customInvoice: false,
            currency: "",

            columns: [
                {
                    dataField: "invoice_date",
                    text: "Datum",
                    sort: true,
                    style: { wordWrap: "break-word" },
                    headerEvents: {
                        onClick: () => {
                            this.props.mapState(
                                "CLIENT_MAP_SORT_DIRECTION",
                                "TOGGLE"
                            );
                            this.getInvoices();
                        },
                    },
                    headerFormatter: (
                        column,
                        index,
                        { sortElement, filterElement }
                    ) => {
                        return (
                            <div>
                                {column.text}{" "}
                                {this.props.sortDirection ? (
                                    <BsCaretDown />
                                ) : (
                                    <BsCaretUp />
                                )}
                            </div>
                        );
                    },
                },
                {
                    dataField: "br_racuna",
                    isDummyField: true,
                    text: "Br. Računa",
                    formatter: (cellContent, row) => {
                        return (
                            <div
                                key={row.uuid}
                                style={{ wordWrap: "break-word" }}
                            >
                                {row.invoice_no}/
                                {row.invoice_business_premises_label}/
                                {row.is_e_commerce === "true" ? row.tid : row.invoice_billing_device_isu}
                            </div>
                        );
                    },
                },
                {
                    dataField: "invoice_business_premises_label",
                    text: "Poslovni Prostor",
                },
                {
                    dataField: "ZKI",
                    text: "ZKI",
                    style: { wordWrap: "break-word" },
                },
                {
                    dataField: "JIR",
                    text: "JIR",
                    style: { wordWrap: "break-word" },
                },
                {
                    dataField: "ukupno",
                    text: "Ukupno",
                    formatter: (cellContent, row) => {
                        var dateParser =
                            /(\d{2})\.(\d{2})\.(\d{4}). (\d{2}):(\d{2}):(\d{2})/;
                        var match = row.invoice_date.match(dateParser);
                        var date = new Date(
                            match[3], // year
                            match[2] - 1, // monthIndex
                            match[1], // day
                            match[4], // hours
                            match[5], // minutes
                            match[6] //seconds
                        );

                        return (
                            <div
                                key={row.uuid}
                                style={{ wordWrap: "break-word" }}
                            >
                                <span>
                                    {row.invoice_amount}{" "}
                                    {date.getFullYear() >= 2023 ? "eur" : "kn"}
                                </span>
                            </div>
                        );
                    },
                },
                {
                    dataField: "pregled",
                    isDummyField: true,
                    text: "Pregled",
                    style: {
                        width: "12em",
                    },
                    formatter: (cellContent, row) => {
                        return (
                            <div
                                key={row.uuid}
                                style={{ wordWrap: "break-word" }}
                            >
                                <div
                                    className="btn btn-primary"
                                    id={row.id}
                                    //onClick={() =>this.seeRacun(row)}
                                    onClick={
                                        /*this.props.generickiPredlozakRacuna ?*/ () =>
                                            this.seeRacun(
                                                row
                                            ) /*: () => this.seeCustomRacun(row) */
                                    }
                                    style={{ marginBottom: "10px" }}
                                >
                                    <AiFillEdit /> Račun
                                </div>
                            </div>
                        );
                    },
                },
            ],
        };
    }

    seeCustomRacun = async (racun) => {
        //OneInvoiceCustom(this.props.customInvoiceFile, racun)
        const input = this.props.customInvoiceFile;

        html2canvas(input, {}).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", -5, 0);
            pdf.save(
                this.props.oneInvoice.invoice_no +
                    "/" +
                    this.props.oneInvoice.invoice_business_premises_label +
                    "/" +
                    this.props.oneInvoice.invoice_billing_device_isu +
                    ".pdf"
            );
        });
    };

    componentDidMount = async () => {
        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", true);
        /*this.setState({
        loading: true
      })*/

        const unHashedJwt = await checkJwt();

        if (!unHashedJwt) {
            logout();
        }

        //await this.getInvoices()

        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", false);
        /*
      this.setState({
          loading: false
      })    */
    };

    getInvoices = async () => {
        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", true);

        const unHashedJwt = await checkJwt();

        if (!unHashedJwt) {
            logout();
        }

        const invoices = await clientInvoices(
            this.props.activePage,
            this.props.pageSize,
            this.props.pickedPosProstor,
            this.props.pickedNapUred,
            this.props.startDate,
            this.props.endDate,
            this.props.sortDirection
        );
        if (!invoices.error) {
            await this.props.mapState("CLIENT_MAP_INVOICES", invoices.data);
        } else {
            sessionStorage.clear();
            this.props.mapState("CLIENT_LOG_OUT");
            this.props.history.replace("/");
        }
        /*
      await Axios( 'client/invoices' + queryData, {
          method: 'get',
          headers: { 'Authorization' : unHashedJwt.data}           
      })
      .then(res => { 
        this.props.mapState("CLIENT_MAP_INVOICES", res.data)      
        /*
          this.setState({
              invoices: res.data
          })
          
          
      })
      .catch(err => {
        if(err.response.status === 400){
            sessionStorage.clear();
            this.props.mapState("CLIENT_LOG_OUT")
            this.props.history.replace("/")
            //window.location = "/"
        }
      })
      */
        this.props.mapState("CLIENT_MAP_LOADING_INVOICES", false);
    };

    handleChange(e) {
        this.setState({
            [e.target.id]: e.target.value,
        });
    }

    handleToggleSidebar() {
        this.props.mapState("ASIDE_TOGGLER", !this.props.asideToggled);
    }

    dateParser(origDate) {
        var dateParser = /(\d{2})\.(\d{2})\.(\d{4}). (\d{2}):(\d{2}):(\d{2})/;
        var match = origDate.match(dateParser);
        var date = new Date(
            match[3], // year
            match[2] - 1, // monthIndex
            match[1], // day
            match[4], // hours
            match[5], // minutes
            match[6] //seconds
        );
        return date;
    }

    compareDates(d1) {
        const date1 = this.dateParser(d1);

        let currency = "KN";

        // check if year is 2024 or greater and show EUR only
        if (date1.getFullYear() >= 2024) {
            currency = "EUR";
        } else if (date1.getFullYear() === 2023) {  // check if year is 2023 and show EUR with KN
            currency = "EUR/KN";
        } else if (date1.getFullYear() === 2022 && date1.getMonth() >= 8) {  // check if year is 2022 and month is August or greater and show KN/EUR
            currency = "KN/EUR";
        }

        console.log(`year is ${date1.getFullYear()}`);
        console.log(`currency is ${currency}`);

        this.setState({ currency: currency });
    }

    seeRacun = (racun) => {
        this.setState({
            oneInvoice: racun,
            racunVisible: true,
        });

        this.compareDates(racun.invoice_date);
    };

    toggleInvoiceVisibility() {
        this.setState({
            oneInvoice: null,
            racunVisible: false,
        });
    }

    handlePageChange(pageNumber) {
        this.props.mapState("CLIENT_MAP_ACTIVE_PAGE", pageNumber);

        this.getInvoices();
    }

    handleItemsPerPageChange(itemsPerPage) {
        this.setState({ itemsPerPage: itemsPerPage });

        this.getInvoices();
    }

    onItemsPerPageChange = async (size) => {
        this.props.mapState("CLIENT_MAP_PAGE_SIZE", size);

        this.getInvoices();
    };

    saveAllToPdf = async () => {
        this.setState({
            loadingAllToExcel: true,
        });

        await SearchedInvoicesToExcel(
            this.props.pickedPosProstor,
            this.props.pickedNapUred,
            this.props.startDate,
            this.props.endDate
        );

        this.setState({
            loadingAllToExcel: false,
        });
    };

    render() {
        return (
            <>
                {this.props.loading ? (
                    <div
                        style={{
                            position: "sticky",
                            marginTop: "50px",
                            left: "50%",
                        }}
                    >
                        <Loader />
                    </div>
                ) : this.props.invoices.total_number_of_records > 0 ? (
                    !this.state.racunVisible ? (
                        <>
                            <BootstrapTable
                                keyField="uuid"
                                data={this.props.invoices.invoices}
                                columns={this.state.columns}
                                bodyStyle={{ wordBreak: "break-word" }}
                            />

                            <div
                                className="row"
                                style={{
                                    margin: "0 auto",
                                    paddingTop: "10px",
                                }}
                            >
                                <Dropdown className="itemsPerPage">
                                    <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                    >
                                        {this.props.pageSize}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() =>
                                                this.onItemsPerPageChange(10)
                                            }
                                        >
                                            10
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() =>
                                                this.onItemsPerPageChange(20)
                                            }
                                        >
                                            20
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() =>
                                                this.onItemsPerPageChange(30)
                                            }
                                        >
                                            30
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() =>
                                                this.onItemsPerPageChange(50)
                                            }
                                        >
                                            50
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Pagination
                                    className="pagination"
                                    firstPageText="1"
                                    lastPageText={Math.ceil(
                                        this.props.invoices
                                            .total_number_of_records /
                                            this.props.pageSize
                                    ).toString()}
                                    hideDisabled
                                    activePage={this.props.activePage}
                                    itemsCountPerPage={this.props.pageSize}
                                    totalItemsCount={
                                        this.props.invoices
                                            .total_number_of_records
                                    }
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />

                                {this.state.loadingAllToExcel ? (
                                    <div
                                        className="btn btn-primary"
                                        style={{
                                            width: "80px",
                                            alignSelf: "center",
                                        }}
                                    >
                                        {" "}
                                        Učitavanje....
                                    </div>
                                ) : (
                                    <div
                                        className="btn btn-primary"
                                        onClick={() => this.saveAllToPdf()}
                                        style={{
                                            width: "80px",
                                            alignSelf: "center",
                                        }}
                                    >
                                        EXCEL
                                    </div>
                                )}
                            </div>
                        </>
                    ) : this.state.currency === "KN" ? (
                        <OneInvoiceKn
                            oneInvoice={this.state.oneInvoice}
                            customInvoiceFile={this.props.customInvoiceFile}
                            toggleInvoiceVisibility={
                                this.toggleInvoiceVisibility
                            }
                            generickiPredlozakRacuna={
                                this.props.generickiPredlozakRacuna
                            }
                        />
                    ) : this.state.currency === "KN/EUR" ? (
                        <OneInvoiceDvojnoKn
                            oneInvoice={this.state.oneInvoice}
                            customInvoiceFile={this.props.customInvoiceFile}
                            toggleInvoiceVisibility={
                                this.toggleInvoiceVisibility
                            }
                            generickiPredlozakRacuna={
                                this.props.generickiPredlozakRacuna
                            }
                        />
                    ) : this.state.currency === "EUR/KN" ? (
                        <OneInvoiceDvojnoEur
                            oneInvoice={this.state.oneInvoice}
                            customInvoiceFile={this.props.customInvoiceFile}
                            toggleInvoiceVisibility={
                                this.toggleInvoiceVisibility
                            }
                            generickiPredlozakRacuna={
                                this.props.generickiPredlozakRacuna
                            }
                        />
                    ) : (
                        <OneInvoiceEur
                            oneInvoice={this.state.oneInvoice}
                            customInvoiceFile={this.props.customInvoiceFile}
                            toggleInvoiceVisibility={
                                this.toggleInvoiceVisibility
                            }
                            generickiPredlozakRacuna={
                                this.props.generickiPredlozakRacuna
                            }
                        />
                    )
                ) : (
                    <>
                        <div style={{ textAlign: "center", margin: "20px" }}>
                            <h1>{this.props.message}</h1>
                        </div>
                        <div></div>
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideToggled: state.clientSettings.asideToggled,
        invoices: state.clientRacuni.invoices,
        pageSize: state.clientRacuni.pageSize,
        activePage: state.clientRacuni.activePage,
        pickedPosProstor: state.clientRacuni.pickedPosProstor,
        pickedNapUred: state.clientRacuni.pickedNapUred,
        startDate: state.clientRacuni.startDate,
        endDate: state.clientRacuni.endDate,
        loading: state.clientRacuni.loadingInvoices,
        sortDirection: state.clientRacuni.sortDirection,
        message: state.clientRacuni.message,
        customInvoiceFile: state.clientSettings.customInvoiceFile,
        generickiPredlozakRacuna: state.clientSettings.generickiPredlozakRacuna,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
        API: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RacuniTable);
